import { render, staticRenderFns } from "./tradingCount.vue?vue&type=template&id=ba7ef4ae&scoped=true&"
import script from "./tradingCount.vue?vue&type=script&lang=js&"
export * from "./tradingCount.vue?vue&type=script&lang=js&"
import style0 from "./tradingCount.vue?vue&type=style&index=0&id=ba7ef4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba7ef4ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\xingxingzu\\multi_merchant_web\\supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba7ef4ae')) {
      api.createRecord('ba7ef4ae', component.options)
    } else {
      api.reload('ba7ef4ae', component.options)
    }
    module.hot.accept("./tradingCount.vue?vue&type=template&id=ba7ef4ae&scoped=true&", function () {
      api.rerender('ba7ef4ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/tradingCount.vue"
export default component.exports